<template>
  <div>
    <!-- <TitleLogo title="공주의 앨범 상세보기" />
    <v-divider></v-divider> -->
    <v-sheet v-if="isLoading" class="text-center mt-10">
      <div class="font-weight-medium text-body-1 pb-4">Loading...</div>
      <v-progress-circular size="48" :width="2" color="primary" indeterminate></v-progress-circular>
    </v-sheet>

    <v-sheet v-else-if="isPremiumPicture" class="premium-album-detail pb-10 mx-auto" :lang="albumLang">
      <header class="premium-album-heading pt-5 pb-4">
        <v-icon class="album-heading-crown" color="#c7a46a" size="24">mdi-crown-outline</v-icon>
        <p>MY PRINCESS ALBUM</p>
        <h1>{{ item.title || "프리미엄 사진" }}</h1>
      </header>

      <div class="premium-photo-frame">
        <v-img :src="item.imageUrl" :lazy-src="item.thumbnailUrl" :key="item.imageUrl" contain aspect-ratio="0.8">
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular color="#b4863e" indeterminate></v-progress-circular>
            </div>
          </template>
        </v-img>
        <div class="premium-photo-plaque">오늘도, 나는 공주</div>
      </div>

      <div class="premium-photo-actions pt-4" :class="{ single: !isPhotoCardEligible }">
        <button type="button" class="album-action secondary" @click="openUrlForDownload">
          <v-icon size="18" color="#a5793c">mdi-download-outline</v-icon>
          <span>사진 저장</span>
        </button>
        <button v-if="isPhotoCardEligible" type="button" class="album-action primary" @click="createPhotoCard">
          <v-icon size="18" color="#ffffff">mdi-crown-outline</v-icon>
          <span>카드 보내기</span>
        </button>
      </div>

      <section v-if="isPhotoCardEligible" class="album-community-section mt-7">
        <div class="album-reply-heading">
          <h2>친구들의 답장</h2>
          <span>{{ replyEntries.length }}</span>
        </div>

        <div class="album-reply-panel">
          <div v-if="replyEntries.length" class="album-reply-list">
            <article v-for="reply in replyEntries" :key="`${reply.cardId}-${reply.id}`">
              <v-icon class="reply-crown" size="18" color="#d88aa0">mdi-crown-outline</v-icon>
              <div>
                <p>{{ reply.message }}</p>
                <small>{{ formatDate(reply.created) }}</small>
              </div>
            </article>
          </div>
          <p v-else class="album-empty-state">이 사진으로 카드를 보내면 친구의 답장이 여기에 모여요.</p>
        </div>
      </section>
    </v-sheet>

    <v-sheet v-else class="pb-4 mx-auto">
      <div class="d-flex justify-center align-center pb-1" style="gap: 16px">
        <IconButton 
              class="picture-action-touch"
              :icon-src="require('@/assets/buttons/download_light_ic.png')"
              :text="$t('button.save')"
              @click="openUrlForDownload()"
              :isLight="true"
            />
            <IconButton 
              class="picture-action-touch"
              :icon-src="require('@/assets/buttons/magic_light_ic.png')"
              :text="$t('button.modify')"
              @click="showEditPreConfirm = true"
              :isLight="true"
            />
            <IconButton 
              class="picture-action-touch"
              :icon-src="require('@/assets/buttons/print_light_ic.png')"
              :text="$t('button.print-1')"
              @click="showPrintConfirm = true"
              :isLight="true"
            />
            <IconButton 
              class="picture-action-touch"
              :icon-src="require('@/assets/buttons/review_light_ic.png')"
              :text="hasReview ? $t('button.review-edit') : $t('button.review-write')"
              @click="writeReview()"
              :isLight="true"
            />
      </div>
      <v-img class="sela-dialog-card-content" :src="item.imageUrl" :lazy-src="item.thumbnailUrl" :key="item.imageUrl" contain>
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular color="white" indeterminate></v-progress-circular>
          </div>
        </template>
      </v-img>
<!--
      <div class="px-4 py-2">
        <PanelButton @click="showEditConfirm = true" :disabled="!isEditable(item)" :title="$t('dialog.edit-composite')" :message="$t('dialog.edit-guide')" />

        <div style="height: 6px"></div>

        <PanelButton @click="goToPrintReq" :title="$t('page.pictureDetail.print-title')" :message="$t('page.pictureDetail.print-subtitle')" />

        <div class="d-flex justify-center align-center py-2" style="gap: 8px">
          <v-btn outlined class="sela deactivate text-body-1" @click="shareImage()" style="flex-grow: 1"> {{ $t("button.friend-share") }} </v-btn>
          <v-btn outlined class="sela deactivate text-body-1" @click="writeReview()" width="32%"> {{ hasReview ? $t("button.review-edit") : $t("button.review-write") }} </v-btn>
          <v-btn outlined class="sela text-body-1" @click="openUrlForDownload()" width="25%"> {{ $t("button.savein-myphone") }}</v-btn>
        </div>
      </div>
-->
      <ReviewWriteDialog v-if="reviewDialog" :visible="reviewDialog" :item="item" @close="reviewDialog = false" :key="item.id" />

      <ConfirmDialog 
        @confirm="editPicture()" 
        @cancel="showEditConfirm = false" 
        :visible="showEditConfirm" 
        :message="$t('dialog.edit-start-confirm')" 
        @input="(e) => (showEditConfirm = e)"
      />
      <ActionConfirmDialog 
        @confirm="goToPrintReq" 
        @cancel="showPrintConfirm = false" 
        :visible="showPrintConfirm" 
        title="즉시 인쇄" 
        :message="$t('dialog.print-warning-guide-message')" 
        @input="(e) => (showPrintConfirm = e)"
        :iconSrc="require('@/assets/buttons/print_light_ic.png')"
        :centerImage="require('@/assets/guide/lafia-print-caution.png')"
      />
      <ActionConfirmDialog 
        @confirm="
          showEditPreConfirm = false
          showEditConfirm = true
        "
        @cancel="showEditPreConfirm = false" 
        :visible="showEditPreConfirm" 
        :title="$t('button.modify')" 
        :message="$t('dialog.edit-pre-warning-guide-message')" 
        @input="(e) => (showEditPreConfirm = e)"
        :iconSrc="require('@/assets/buttons/magic_light_ic.png')"
        :centerImage="require('@/assets/guide/lafia-magic-caution.png')"
      />
    </v-sheet>
  </div>
</template>
<script>
import TitleLogo from "@/views/components/TitleLogo"
import DialogHeader from "@/views/components/DialogHeader"
import ReviewWriteDialog from "./components/ReviewWriteDialog"
import { fetchMyPictureItem } from "@/models/MyPicture"
import ConfirmDialog from "@/views/components/ConfirmDialog"
//import PanelButton from "@/views/components/PanelButton"
import IconButton from "@/views/components/IconButton"
import ActionConfirmDialog from "@/views/components/ActionConfirmDialog"
import { savePhotoForBrowser } from "@/util/photo-save"

export default {
  components: {
    TitleLogo,
    DialogHeader,
    ReviewWriteDialog,
    ConfirmDialog,
    //PanelButton,
    IconButton,
    ActionConfirmDialog,
  },

  data: () => ({
    item: null,
    isLoading: true,
    reviewDialog: false,
    hasReview: false,
    showEditConfirm: false,

    showPrintConfirm: false,
    showEditPreConfirm: false,
    replySources: [],
    isPhotoCardEligible: false,
  }),

  created() {},

  mounted() {
    if (this.isPremiumPicture) {
      this.loadPremiumPicture()
      return
    }

    fetchMyPictureItem(this, this.$route.params.id)
      .then((item) => {
        this.item = item
        console.log("MyPictureDialog mounted", this.item)

        if (this.item) {
          this.$http
            .post("/api/review/select/request", {
              params: {
                requestId: this.item.id,
              },
            })
            .then((res) => {
              if (res.data.length > 0) {
                this.hasReview = true
              } else {
                this.hasReview = false
              }
            })
        }
      })
      .catch((e) => {
        console.log(e)
        alert(this.$t("alert.error_failed_get_information"))
        this.$router.back()
      })
      .finally(() => {
        this.isLoading = false
      })
  },

  computed: {
    isPremiumPicture() {
      return /^premium-\d+$/.test(String(this.$route.params.id || ""))
    },
    premiumAssetId() {
      const match = String(this.$route.params.id || "").match(/^premium-(\d+)$/)
      return match ? Number(match[1]) : null
    },
    replyEntries() {
      return this.replySources
        .reduce((result, card) => {
          return result.concat(
            (card.replies || []).map((reply) => ({
              ...reply,
              cardId: card.id,
            }))
          )
        }, [])
        .sort((left, right) => new Date(right.created) - new Date(left.created))
    },
    albumLang() {
      return this.$i18n && this.$i18n.locale === "jp" ? "ja" : (this.$i18n && this.$i18n.locale) || "ko"
    },
  },

  methods: {
    async loadPremiumPicture() {
      try {
        const photoResponse = await this.$http.get(
          `/api/photo-deliveries/completed/${this.premiumAssetId}`
        )
        const photo = photoResponse.data
        this.item = {
          ...photo,
          imageUrl: photo.complete_url,
          thumbnailUrl: photo.thumbnail_url,
        }

        try {
          const eligibilityResponse = await this.$http.get(
            "/api/photo-cards/eligibility"
          )
          this.isPhotoCardEligible = Boolean(eligibilityResponse.data.eligible)
          if (this.isPhotoCardEligible) {
            const cardResponse = await this.$http.get(
              `/api/photo-cards/mine?assetId=${this.premiumAssetId}`
            )
            this.replySources = cardResponse.data.cards || []
          }
        } catch (error) {
          console.log("photo card lookup unavailable", error)
          this.isPhotoCardEligible = false
          this.replySources = []
        }
      } catch (error) {
        console.log(error)
        alert(this.$t("alert.error_failed_get_information"))
        this.goToAlbum()
      } finally {
        this.isLoading = false
      }
    },

    goToAlbum() {
      this.$router.push("/mypage/home?type=picture")
    },

    createPhotoCard() {
      const reservationId = encodeURIComponent(this.item.reservation_id || "")
      window.location.href = `/photo-card/create.html?assetId=${this.premiumAssetId}&reservationId=${reservationId}`
    },

    formatDate(value) {
      if (!value) return ""
      return this.dayjs(value).format("YYYY.M.D")
    },

    async shareImage() {
      await this.$shareLink(this.item.imageUrl)
    },

    writeReview() {
      this.reviewDialog = true
    },

    downloadImage() {
      const a = document.createElement("a")
      a.href = this.item.imageUrl
      a.download = this.item.filename
      a.click()
    },
    openUrlForDownload() {
      const photoUrl = this.item && (this.item.complete_url || this.item.imageUrl)
      if (!photoUrl) return

      savePhotoForBrowser({
        photoUrl,
        fileName: (this.item && (this.item.filename || this.item.original_name)) || "lafia-photo.jpg",
      })
    },
    editPicture() {
      this.$router.push(`/mypage/picEdit/${this.item.id}`)
    },

    isEditable(item) {
      if (!item.editable || !item.completeDate) {
        return false
      }
      const isBaseEditableDate = "24.5.1"
      const isBaseEditableDay = this.dayjs(isBaseEditableDate, "YY.M.D", true)
      const completeDay = this.dayjs(item.completeDate, "YY.M.D", true)

      if (completeDay.isBefore(isBaseEditableDay)) {
        return false
      } else {
        return true
      }
    },

    goToPrintReq() {
      this.$router.push({ name: "printPicPay", params: { id: this.$route.params.id, pic: this.item } })
    },
  },
}
</script>
<style scoped>
.picture-action-touch {
  min-width: 56px;
  min-height: 56px;
  padding: 5px 6px;
  justify-content: center;
  touch-action: manipulation;
  user-select: none;
}

.premium-album-detail {
  max-width: 580px;
  color: #2d2527;
  background: #fffaf7;
  --album-font-body: "NanumSquare", sans-serif;
  --album-font-display: "Cafe24Danjunghae", serif;
  font-family: var(--album-font-body);
}

.premium-album-detail:lang(ja) {
  --album-font-body: "Noto Sans JP", sans-serif;
  --album-font-display: "Noto Sans JP", sans-serif;
}

.premium-album-heading {
  width: 93%;
  margin: 0 auto;
  text-align: center;
}

.premium-album-heading p {
  margin: 5px 0 2px;
  color: #c7a46a;
  font-size: 11px;
  letter-spacing: 0.18em;
}

.premium-album-heading h1 {
  margin: 0;
  color: #6f5038;
  font-family: var(--album-font-display);
  font-size: 27px;
  font-weight: 400;
  line-height: 1.35;
}

.album-heading-crown {
  display: block;
  width: 44px;
  margin: -4px auto 0;
}

.premium-photo-frame {
  position: relative;
  width: 99%;
  aspect-ratio: 4 / 5;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 0;
  background: transparent;
  box-shadow: 0 14px 32px rgba(93, 60, 55, 0.14);
}

.premium-photo-frame::after {
  position: absolute;
  z-index: 3;
  inset: 0;
  background: url("~@/assets/mypage/premium-album-frame.png") center / 100% 100% no-repeat;
  content: "";
  pointer-events: none;
}

.premium-photo-frame .v-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 93.9394%;
  height: 93.9394%;
  transform: translate(-50%, -50%);
}

.premium-photo-plaque {
  position: absolute;
  z-index: 4;
  right: 20%;
  bottom: 1.6%;
  left: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 8%;
  min-height: 0;
  padding: 0 8px;
  color: #72563f;
  background: transparent;
  font-family: var(--album-font-display);
  font-size: 14px;
  line-height: 1.3;
  text-align: center;
}

.premium-photo-actions {
  display: grid;
  width: 93%;
  margin: 0 auto;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 9px;
}

.premium-photo-actions.single {
  grid-template-columns: 1fr;
}

.album-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 50px;
  border-radius: 9px;
  font-size: 15px;
  font-weight: 700;
}

.album-action.secondary {
  border: 1px solid #d8bc8d;
  color: #8a642b;
  background: #fffdfb;
}

.album-action.primary {
  border: 1px solid #cf7891;
  color: #fff;
  background: #d88aa0;
  box-shadow: 0 8px 18px rgba(165, 84, 109, 0.2);
}

.album-community-section {
  width: 93%;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  border: 1px solid #eadde1;
  border-radius: 15px;
  background: #fffdfb;
}

.album-reply-heading {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 55px;
  border-bottom: 1px solid #eadde1;
  color: #a5546d;
  background: #fff7f9;
  font-size: 15px;
  font-weight: 700;
}

.album-reply-heading h2 {
  margin: 0;
  font: inherit;
}

.album-reply-heading::after {
  position: absolute;
  right: 28%;
  bottom: 0;
  left: 28%;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: #c7a46a;
  content: "";
}

.album-reply-heading span {
  color: inherit;
  font-size: 13px;
}

.album-reply-panel {
  padding: 14px;
}

.album-reply-list {
  display: grid;
  gap: 8px;
}

.album-reply-list article {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 13px;
  border: 1px solid rgba(234, 221, 225, 0.7);
  border-radius: 11px;
  background: #fffaf7;
}

.reply-crown {
  flex: 0 0 auto;
  margin-top: 1px;
}

.album-reply-list p {
  margin: 0 0 4px;
  font-size: 14px;
  line-height: 1.55;
}

.album-reply-list small {
  color: #948178;
  font-size: 10px;
}

.album-empty-state {
  margin: 0;
  padding: 28px 12px;
  color: #8e7d74;
  text-align: center;
  font-size: 13px;
}

@media (max-width: 360px) {
  .premium-album-heading h1 {
    font-size: 24px;
  }

  .premium-photo-plaque {
    right: 18%;
    left: 18%;
    font-size: 13px;
  }

  .album-reply-heading {
    font-size: 13px;
  }
}
</style>
